import React from 'react';
import PropTypes from 'prop-types';

import PrioritySelector from 'core/gd-components/priority-selector/priority';

export default class GDPrioritySelect extends React.Component {
    static propTypes = {
        form: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired,

        priorityOptions: PropTypes.array.isRequired,
        noEmergency: PropTypes.bool,
        noBlocker: PropTypes.bool,

        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        targetOffset: PropTypes.string,

        onPrioritySelect: PropTypes.func,
        onTogglePopover: PropTypes.func
    }

    static defaultProps = {
        name: 'priority'
    }

    UNSAFE_componentWillMount() {
        this.props.form.registerFormComponent(this.props.name,this);
    }

    triggerOnChange = (changedValue) => {

        if (this.props.form) {
            this.props.form.onElementChange(this.props['form-field'],changedValue);
        }

        if (this.props.onChange) {
            this.props.onChange(changedValue);
        }
    };

    onPrioritySelect = (newValue, confirmCallback) => {
        const { onPrioritySelect } = this.props;

        if (onPrioritySelect) {
            onPrioritySelect(newValue, confirmCallback)
        } else {
            this.props.form.onFormComponentValueChange(this.props.name,newValue);
            confirmCallback(newValue);
        }
    };

    render() {
        const { form, name, priorityOptions } = this.props;
        let value = form.getValue(name);

        let valueFound = (!value);
        if (value && priorityOptions) priorityOptions.map(function(option){
            if (option.value === value) valueFound = true;
        });

        if (!valueFound) {
            console.warn("GDPrioritySelect: value is not found within options. reset to null;");
            value = null;
            form.setValue(name,null,{silent: true})
        }

        return (
            <PrioritySelector className={Classes('list-new-style', /*'form-style',*/ this.props.className)}
                              onUserSelect={this.onPrioritySelect}
                              options={this.props.priorityOptions}
                              value={value}
                              placeholder="Priority"
                              noEmergency={this.props.noEmergency}
                              noBlocker={this.props.noBlocker}
                              attachment={this.props.attachment}
                              targetAttachment={this.props.targetAttachment}
                              targetOffset={this.props.targetOffset}
                              onTogglePopover={this.props.onTogglePopover}/>
        );
    }
}